/**
 * Curated US IANA zones for venue picker (subset — extend as needed).
 */

const US_TIME_ZONE_GROUPS = [
  {
    label: "Eastern",
    options: [
      { value: "America/New_York", label: "Eastern — New York" },
      { value: "America/Detroit", label: "Eastern — Detroit" },
      { value: "America/Kentucky/Louisville", label: "Eastern — Louisville" },
      { value: "America/Indiana/Indianapolis", label: "Eastern — Indianapolis" },
    ],
  },
  {
    label: "Central",
    options: [
      { value: "America/Chicago", label: "Central — Chicago" },
      { value: "America/Menominee", label: "Central — Menominee" },
      { value: "America/North_Dakota/Center", label: "Central — North Dakota" },
    ],
  },
  {
    label: "Mountain",
    options: [
      { value: "America/Denver", label: "Mountain — Denver" },
      { value: "America/Boise", label: "Mountain — Boise" },
      { value: "America/Phoenix", label: "Arizona — Phoenix (no DST)" },
    ],
  },
  {
    label: "Pacific",
    options: [
      { value: "America/Los_Angeles", label: "Pacific — Los Angeles" },
      { value: "America/Tijuana", label: "Pacific — Tijuana" },
    ],
  },
  {
    label: "Alaska & Hawaii",
    options: [
      { value: "America/Anchorage", label: "Alaska — Anchorage" },
      { value: "Pacific/Honolulu", label: "Hawaii — Honolulu" },
    ],
  },
];

/**
 * Rough continental-US IANA guess from lat/lng for picker suggestions only.
 * Alaska/Hawaii use bbox checks; otherwise longitude bands (no DST edge cases).
 */
function suggestUsIanaTimeZoneFromCoords(lat, lng) {
  if (
    typeof lat !== "number" ||
    typeof lng !== "number" ||
    Number.isNaN(lat) ||
    Number.isNaN(lng)
  ) {
    return null;
  }
  if (lat >= 50 && lng <= -125 && lng >= -175) {
    return "America/Anchorage";
  }
  if (lat >= 18 && lat <= 23 && lng >= -161 && lng <= -154) {
    return "Pacific/Honolulu";
  }
  if (lng >= -87) {
    return "America/New_York";
  }
  if (lng >= -102) {
    return "America/Chicago";
  }
  if (lng >= -114) {
    return "America/Denver";
  }
  return "America/Los_Angeles";
}

module.exports = {
  US_TIME_ZONE_GROUPS,
  suggestUsIanaTimeZoneFromCoords,
};
